import styled from 'styled-components';

const NoResultsContainer = styled.div`
    align-items: center;
    display: flex;
    justify-content: center;
`;

export default NoResultsContainer;
